import { useState } from "react";
import { useTranslation } from "react-i18next";
import Details from "components/Organisms/vendor/details";
import { handleTabChange } from "services/modules/utils/Helper";
import VendorDetailsTemplate from "../../templates/vendor/vendorListing/vendorDetails";
import VendorProductsPage from "./vendorProducts";

export default function VendorDetailsPage({
  details,
  setOpenDeleteModal,
  actionsList,
  approvalStatusOptions,
}) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useState(
    new URLSearchParams(window.location.search),
  );
  const selectedTab = searchParams.get("tab");
  const [value, setValue] = useState(+selectedTab || 0);

  const tabs = [
    {
      title: t("vendors.tab_details"),
      children: <Details details={details} />,
    },
    {
      title: t("vendors.tab_products"),
      children: <VendorProductsPage list={details?.variants} />,
    },
  ];

  return (
    <VendorDetailsTemplate
      details={details}
      setOpenDeleteModal={setOpenDeleteModal}
      selectedTab={value}
      tabs={tabs}
      handleTabChange={(event, newValue) =>
        handleTabChange({
          event,
          newValue,
          setValue,
          searchParams,
          setSearchParams,
        })
      }
      actionsList={actionsList}
      approvalStatusOptions={approvalStatusOptions}
    />
  );
}
